<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Document</title>
  </head>
  <body>
    <app-modal-rendez-vous></app-modal-rendez-vous>
    <app-contact></app-contact>
    <header>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-4 col-md-3 col-12 header-item">
            <img
              id="sinepsyLogo"
              class="header sinepsyLogoHeader"
              src="/assets/images/header/logo-sinepsy.png"
              alt="Sinepsy logo"
              [routerLink]="['/accueil']"
            />
          </div>
          <div id="titre-header" class="col-sm-4 col-md-6 col-12 header-item">
            <h1 class="text-center">Service Intégral</h1>
            <h2 class="text-center">
              en Neurosciences et Psychologie Clinique
            </h2>
          </div>
          <div class="col-sm-4 col-md-3 col-12 header-item">
            <a
              id="btn-rdv-doctolib"
              class="btn btn-light"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#modalRdv"
            >
              Prendre RDV
              <img
                id="doctolibLogo"
                class="header doctolibLogoHeader"
                src="/assets/images/header/logo-doctolib.png"
                alt="Docotlib logo"
              />
            </a>
            <link
              rel="stylesheet"
              href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"
            />
            <a
              href="https://api.whatsapp.com/send?phone=+33650564742&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Varela%202."
              class="float"
              target="_blank"
              title="contact via Whatsapp"
            >
              <!-- 51955081075 -->
              <i class="fa fa-whatsapp my-float"></i>
            </a>
            <a
              href="tel:+33650564742"
              class="float2"
              title="contact par téléphone"
            >
              <i class="fa fa-phone my-float"></i>
            </a>
          </div>
        </div>
      </div>

      <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <div class="container-fluid">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#main_nav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="main_nav">
            <ul class="navbar-nav mx-auto">
              <li id="accueilNavItem" class="nav-item active">
                <a class="nav-link" [routerLink]="['/accueil']">Accueil </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/a-propos']"> À propos </a>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  Services
                </a>
                <ul class="dropdown-menu">
                  <!-- <li>
                  <a class="dropdown-item" [routerLink]="['/questionnaire']">
                    Questionnaire</a
                  >
                </li> -->
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="['/neuropsychologie']"
                    >
                      Neuropsychologie</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="['/psychologie-clinique']"
                    >
                      Psychologie clinique
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-bs-toggle="modal"
                  data-bs-target="#modalContact"
                  style="cursor: pointer"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <!-- navbar-collapse.// -->
        </div>
        <!-- container-fluid.// -->
      </nav>
    </header>
  </body>
</html>
